export function currency(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) return "—";
  return `$${v.toLocaleString("en-NZ", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}

export function pct(v: number | null | undefined, decimals = 1): string {
  if (v == null || !Number.isFinite(v)) return "—";
  return `${v.toFixed(decimals)}%`;
}

export function num(v: number | null | undefined, decimals = 0): string {
  if (v == null || !Number.isFinite(v)) return "—";
  return v.toLocaleString("en-NZ", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function formatCurrencyInput(v: number | null): string {
  if (v == null || !Number.isFinite(v)) return "";
  const decimals = Number.isInteger(v) ? 0 : 2;
  return `$${v.toLocaleString("en-NZ", { minimumFractionDigits: decimals, maximumFractionDigits: 2 })}`;
}

export function parseCurrencyInput(v: string): number | null {
  const cleaned = v.replace(/[$,\s]/g, "").trim();
  if (cleaned === "") return null;
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : null;
}
